import { defineAction } from '~/prix'
import actionJson from './communityGardenDocumentUpdate.action.json' with { type: 'json' }
import { communityGardenDocumentObject } from '../communityGardenDocumentObject'
import { z } from 'zod'

const definition = defineAction({
  ...actionJson,
  input: communityGardenDocumentObject
    .pick({ id: true, fileName: true, mimeType: true, status: true })
    .partial()
    .required({ id: true }),
  output: communityGardenDocumentObject,
})

export default definition
